import React from 'react';
import { Popover } from 'antd';
import { Link } from 'react-router-dom';

export class UserListLink extends React.Component {
    text_truncate = function (str, length, ending) {
        if (str) {
            if (length == null) {
                length = 100;
            }
            if (ending == null) {
                ending = '...';
            }
            if (str.length > length) {
                return str.substring(0, length - ending.length) + ending;
            } else {
                return str;
            }
        } else {
            return 'No Bio Written'
        }
    };

    renderUserOrg() {
        let account;
        if (this.props.includeOrg) {
            if (this.props.userName === this.props.orgName) {
                account = <div className="italic">Single User Account</div>;
            } else {
                account = (
                    <div className="organization-row dotDot">
                        {(this.props.linksOff) ? <div>{this.props.orgName}</div> :
                            <Link
                                tag={Link}
                                className="acc-font bold clickable"
                                to={`/organization/${this.props.orgId}/summary`}
                            >
                                {this.props.orgName}
                            </Link>
                        }
                    </div>
                );
            }
        }
        return (
            <div>
                {account}
            </div>
        );
    }

    render() {
        return (
            <div className={this.props.userListLinkClass}>
                <div className={`${(this.props.userClass) ? this.props.userClass : 'user-row'} column dotDot`}>
                    {(this.props.linksOff) ? <div className="column pad-right-5">{this.props.userName}</div> :
                        <Link
                            tag={Link}
                            className="acc-font bold clickable"
                            to={`/user/${this.props.userId}/summary`}
                        >
                            {this.props.userName}
                        </Link>
                    }
                </div>
                {(this.props.autobiography) ?
                    <Popover
                        content={<div className="text-small bio-pop">{this.text_truncate(this.props.autobiography, 300, '...')}</div> || 'No Bio Written'}
                        trigger="hover"
                        placement="right"
                    ><div className="icon-ios-body bio-link clickable"></div></Popover> : ''}
                <div className="clear"></div>
                {this.renderUserOrg()}
            </div>
        )
    }
}